<template>
  <div class="l-swiper-container swiper-no-swiping">
    <swiper ref="mySwiper" :options="swiperOption">
      <swiper-slide v-for="(item, index) in swiperData" :key="index">
        <img :src="item.imageNameUrl" alt :style="{ 'max-height': imgHeight + 'px' }" />
      </swiper-slide>
    </swiper>
    <!-- <div class="swiper-button-prev" slot="button-prev"></div>
    <div class="swiper-button-next" slot="button-next"></div>-->
    <LButtonCommon class="swiper-button-prev" :type="1" />
    <LButtonCommon class="swiper-button-next" :type="2" />
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import LButtonCommon from '@/views/learn-new/components/l-button-common'

let vm
export default {
  name: 'l-swiper',
  components: {
    swiper,
    swiperSlide,
    LButtonCommon,
  },
  props: {
    swiperData: {
      type: Array,
    },
    swiperIndex: {
      type: Number,
    },
  },
  inject: ['resizeStatus'],
  data() {
    return {
      swiperLength: 0,
      imgHeight: 0, // 图片高度
      swiperOption: {
        // 轮播图配置
        watchSlidesProgress: true,
        slidesPerView: 'auto',
        centeredSlides: true,
        autoplay: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        on: {
          // 切换事件
          slideChange: function () {
            vm.$emit('slidechange', {
              index: this.activeIndex,
              length: vm.swiperLength,
            })
            // 缓存 userid+元素id
          },
          resize: function () {
            setTimeout(() => {
              vm.swiper.update()
            }, 500) //延时器很重要，不加可能会出错
          },
        },
      },
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    },
    changeSwiper() {
      return this.resizeStatus.status
    },
  },
  watch: {
    swiperIndex(val) {
      // 监听index变化
      if (val) {
        this.swiper.slideTo(val, 1000, false)
      }
    },
    swiperData(val) {
      // 监听数组变化
      if (val) {
        this.swiperLength = val.length
      }
    },
    changeSwiper(newval, oldVal) {
      if (newval != oldVal) {
        this._resize()
      }
    },
  },
  mounted() {
    vm = this // 指向vue
    this.swiperLength = this.swiperData.length
    window.onresize = () => {
      vm._setHeight()
    }
    vm._setHeight()
  },
  destroyed() {
    window.onresize = null
  },
  methods: {
    _resize() {
      setTimeout(() => {
        this.swiper.update()
      }, 500)
    },
    // 设置高度
    _setHeight() {
      this.imgHeight = document.documentElement.clientHeight * 0.7
    },
  },
}
</script>

<style lang="stylus" scoped>
@import './index.styl'
</style>
